import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteListItem, setItems } from "store/actions/Store/item";
import { MdDelete, MdLock } from "react-icons/md";
import Modal from "pages/Profile/components/Modal";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "store/services/Profile/profile";
import {
  getPaymentDetail,
  getUserList,
  handleListRequest,
} from "store/services/Store/List";
import { showToast } from "utils/showToast";
import { setListOrderPreference } from "store/actions/Store/list";
import Loader from "components/Loader";
import { OrderDeliveryPickupInfo } from "constants";

const ReviewList = () => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);
  const { activeList, list } = useSelector((store) => store.storeLists);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isClicked, setIsClicked] = useState(true);
  const [listItems, setListItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([{}]);
  const [itemQuantities, setItemQuantities] = useState({});
  const [userProfile, setUserProfile] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [placeholderVisible, setPlaceholderVisible] = useState(false);
  const fetchData = async () => {
    try {
      if (user && selectedStore && activeList) {
        const store_id = selectedStore.id;
        const userList = await getUserList(
          user.accessToken,
          user.data.id,
          store_id,
          list.list_id
        );
        if (userList.success) {
          let { items } = userList.data;
          const profile = await getUserProfile(user.accessToken, user.data.id);
          setListItems(items);
          setUserProfile(profile.data);
          dispatch(setItems(listItems));
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (selectedStore && user) {
      const fetch = async () => {
        try {
          if (user && selectedStore) {
            const store_id = selectedStore.id;
            const userList = await getUserList(
              user.accessToken,
              user.data.id,
              store_id,
              list.list_id
            );
            if (userList.success) {
              let { items } = userList.data;
              const profile = await getUserProfile(
                user.accessToken,
                user.data.id
              );
              setListItems(items);
              setUserProfile(profile.data);
              dispatch(setItems(items));
            }
          }
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      };
      fetch();
    }
  }, [dispatch, list, selectedStore, user]);

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const onClickHandler = () => {
    if (!list.active) {
      showToast("Make List active to place order", "error", true);
      return;
    }
    const isPricesUpdated = listItems?.filter(
      (li) => li.isPriceUpdated === true
    );
    if (isPricesUpdated.length === 0) {
      setModalContent({
        title: "Note",
        description: "How would you like to receive your order?",
        redButton: "Delivery",
        purpleButton: "Pickup",
        backgroundColor: "theme-color",
        flag: true,
      });
    }
    if (
      userProfile &&
      (userProfile.first_name === "" ||
        userProfile.last_name === "" ||
        userProfile.phone_number === "" ||
        userProfile.location === "" ||
        userProfile.location === null)
    ) {
      setModalContent({
        title: "Note",
        description: "Please complete your profile before placing an order",
        redButton: "CANCEL",
        purpleButton: "PROFILE",
      });
    } else if (isPricesUpdated) {
      if (isPricesUpdated.length > 0) {
        const itemsName = isPricesUpdated.map((iName) => iName.name);
        if (itemsName.length > 0) {
          const lastItem = itemsName.pop();
          const itemsString = itemsName.join(", ");
          let message = `The prices of `;
          if (itemsName.length > 0) {
            message += `${itemsString}, and ${lastItem} have been changed. Make sure to review your list before placing the order.`;
          } else {
            message += `${lastItem} has been changed. Make sure to review your list before placing the order.`;
          }
          setModalContent({
            title: "Note",
            description: message,
            purpleButton: "PLACE ORDER",
            redButton: "REVIEW",
          });
        }
      }
    } else if (isClicked && isPricesUpdated.length === 0) {
      setModalContent({
        title: "Note",
        description: "How would you like to receive your order?",
        redButton: "Delivery",
        purpleButton: "Pickup",
        backgroundColor: "theme-color",
        flag: true,
      });
    }
    setIsClicked(false);
    handleModalToggle();
  };
  const handleQuantityChange = (e, item, itemId) => {
    if (item.EAN13 === itemId) {
      setPlaceholderVisible(false);
    }
    const newItemId = item.EAN13;
    let newQuantity = parseFloat(e.target.value);
    if (e.target.value === "") {
      newQuantity = undefined;
    } else if (newQuantity === 0 || isNaN(newQuantity)) {
      newQuantity = item.quantity;
    }

    setItemQuantities((prevQuantities) => ({
      ...prevQuantities,
      [newItemId]: newQuantity,
    }));
  };
  const handleSaveChanges = async () => {
    try {
      if (!list.active) {
        showToast("Make List active to add quantity", "error", true);
        return;
      }
      const resultArray = [];
      for (const item of listItems) {
        if (itemQuantities.hasOwnProperty(item.EAN13)) {
          resultArray.push({
            EAN13: item.EAN13,
            value: itemQuantities[item.EAN13],
          });
        }
      }
      const apiRequests = resultArray.map((item) => {
        const result = handleListRequest({
          method: "post",
          url: `users/${user.data.id}/lists/${list.list_id}/items/${item.EAN13}`,
          token: user.accessToken,
          data: {
            store_id: selectedStore.id,
            quantity: item.value,
          },
        });
        return result;
      });
      const results = await Promise.all(apiRequests);
      const isSuccess = results.every((res) => res.success === true);
      if (isSuccess) {
        fetchData();
        showToast("List updated successfully", "success", true);
        setItemQuantities({});
      } else if (!isSuccess || activeList.lock) {
        showToast(
          "Can not add/update items in a inactive list, kindly make list active to proceed",
          "error",
          false,
          "OK"
        );
        return;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleLockMessage = () => {
    showToast(
      "Can not add/update items in a locked list, kindly unlock to proceed",
      "error",
      false,
      "OK"
    );
  };
  const handleDeleteItem = async (item) => {
    try {
      if (!list.active) {
        showToast("Make List active to delete quantity", "error", true);
        return;
      }
      const item_ean13 = item.EAN13;
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const deleteItem = await handleListRequest({
        method: "delete",
        url: `users/${user.data.id}/lists/${
          list.list_id
        }/items/${item_ean13}/?delete_all=${true}`,
        token: user.accessToken,
      });
      if (deleteItem.success) {
        const filterList = listItems.filter((fl) => fl.EAN13 !== item_ean13);
        setFilteredItems(filterList);
        dispatch(deleteListItem(item_ean13));
        setListItems(filterList);
        dispatch(setItems(filterList));
        showToast(deleteItem.data, "success", true);
        fetchData();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return <Loader />;
  }
  const getOfferDiscount = async () => {
    try {
      const result = await getPaymentDetail(
        user.accessToken,
        user.data.id,
        selectedStore.id,
        activeList.list_id
      );
      const { discountPercentage, totalPrice, discountedPrice } =
        result.data.data;
      setDiscount({ discountPercentage, totalPrice, discountedPrice });
      return discount;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handlePlaceOrder = async (prefernceValue) => {
    const discountOffer = await getOfferDiscount();
    if (modalContent.purpleButton === "PROFILE") {
      navigate(`/users/${user.data.id}/updateProfile`);
    } else if (modalContent.purpleButton === "PLACE ORDER") {
      setModalContent({
        title: "Note",
        description: "How would you like to receive your order?",
        redButton: "Delivery",
        purpleButton: "Pickup",
        backgroundColor: "theme-color",
        flag: true,
      });
      setIsModalOpen(false);
      setIsModalOpen(true);
    } else if (modalContent.purpleButton === "CONTINUE") {
      let itemsDescription;
      if (listItems?.length > 0) {
        const items = listItems.map((listItem) => {
          return { name: listItem.name, price: listItem.price };
        });

        if (items.length > 0) {
          itemsDescription = items.map(
            (item) => `${item.name} - £${item.price}`
          );
        }
      }
      if (discountOffer) {
        const discountModaldata = {
          title: `You got ${discount?.discountPercentage}% off!`,
          heading: "Items:",
          description: itemsDescription,
          discountFlag: true,
          orignalPrice: `£${parseFloat(discount?.totalPrice).toFixed(2)}`,
          discount: `£${(
            parseFloat(discount?.totalPrice) -
            parseFloat(discount?.discountedPrice)
          ).toFixed(2)}`,
          discountedPrice: `£${parseFloat(discount?.discountedPrice).toFixed(
            2
          )}`,
          purpleButton: "PROCEED",
          redButton: "CANCEL",
        };
        setModalContent(discountModaldata);
        setIsClicked(true);
      }
    } else if (
      modalContent.redButton === "Delivery" ||
      modalContent.purpleButton === "Pickup"
    ) {
      dispatch(setListOrderPreference(prefernceValue));
      setModalContent({
        title: "Note",
        description: OrderDeliveryPickupInfo(prefernceValue),
        purpleButton: "CONTINUE",
        redButton: "CANCEL",
      });
      setIsModalOpen(false);
      setIsModalOpen(true);
    } else if (modalContent.purpleButton === "PROCEED") {
      navigate(
        `/users/${user.data.id}/store/${selectedStore.id}/lists/${activeList.list_id}/order`
      );
    }
  };

  if (list?.lock && !list.isOrderPlaced) {
    return (
      <div className="flex items-center justify-center min-h-screen gap-2 text-center">
        <p>Active list is locked</p>
        <div>
          <MdLock size={20} />
        </div>
        <p>Kindly unlock to review the list</p>
      </div>
    );
  }
  return (
    <div
      className={
        !list || list?.items_count === 0 || filteredItems.length === 0
          ? "flex items-center justify-center h-screen"
          : "border border-gray-50"
      }
    >
      {!list || list?.items_count === 0 || filteredItems.length === 0 ? (
        <div className="flex items-center justify-center min-h-screen mb-16 text-center ">
          {list ? "No items added in the list yet" : "No Active list found"}
        </div>
      ) : (
        <div className="min-h-screen mt-16 ">
          {listItems && (
            <div
              style={{
                color: selectedStore?.theme.color,
              }}
              className={`p-4 mt-4  md:text-lg text-sm lg:text-xl font-bold text-center border shadow-lg bg-gray-50 border-gray-50 ${
                list.owner ? "" : "hidden"
              }`}
            >
              <button
                className={`  ${list.isOrderPlaced ? "disabled" : ""}`}
                onClick={onClickHandler}
                disabled={list.isOrderPlaced}
              >
                {list.isOrderPlaced ? "Order Placed" : "Place Order"}
              </button>
            </div>
          )}

          {listItems &&
            listItems.map((item) => {
              const itemId = item.EAN13;
              return (
                <div key={itemId} className="px-4 md:px-0 lg:px-0">
                  <div className="flex items-center h-20 max-w-5xl mx-auto my-2 border-none rounded-lg shadow-2xl md:my-6 lg:my-6 justify-evenly lg:h-48 md:h-32 md:w-2/3 lg:w-2/3 bg-gray-50 ">
                    <div className="flex items-center justify-start w-2/4 h-full pl-1 md:justify-center lg:justify-center lg:px-6">
                      <div className="flex items-center justify-center w-20 h-20 lg:h-44 lg:w-44 md:h-32 md:w-32">
                        <img
                          className="object-contain p-3 lg:w-full md:h-full md:w-full lg:h-full"
                          src={item.logo}
                          alt=""
                        />
                      </div>
                      <div className="w-2/5 text-xs font-bold text-gray-700 lg:text-2xl md:text-xl">
                        {item.descriptionLong}
                      </div>
                    </div>
                    <div className="flex items-center justify-center w-2/4 h-full ">
                      <div className="flex items-center justify-center md:gap-0 lg:gap-7">
                        <div className="flex flex-col items-start justify-start py-2 md:items-center lg:items-center md:flex-row lg:flex-row">
                          <div className="flex items-center w-full gap-3 text-sm ">
                            <div>
                              {" "}
                              <input
                                style={{
                                  borderColor: selectedStore?.theme.color,
                                }}
                                className={`w-16 px-2 py-auto text-sm text-center border  ${
                                  placeholderVisible
                                    ? "custom-placeholder-remove"
                                    : "custom-placeholder"
                                }`}
                                type="text"
                                min="0"
                                pattern="[0-9]+"
                                placeholder={item.quantity}
                                value={itemQuantities[itemId]}
                                onChange={(e) =>
                                  handleQuantityChange(e, item, itemId)
                                }
                              />
                            </div>
                            <div className="w-12 text-xs md:text-lg lg:text-lg ">
                              {" "}
                              {item.unit}
                            </div>
                          </div>

                          <div className="w-24 mt-1 text-xs font-bold lg:text-lg md:text-lg text-start ">
                            £ {item.price_per_quantity}
                          </div>
                        </div>
                        <div>
                          <MdDelete
                            onClick={() => handleDeleteItem(item)}
                            size={25}
                            style={{
                              color: selectedStore?.theme.color,
                            }}
                            className={` hover:text-red-800 ${
                              list?.isOrderPlaced ? "hidden" : ""
                            }`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          {listItems && (
            <div
              className={`${
                list?.isOrderPlaced ? "hidden" : "inline-block"
              } flex items-end justify-end mb-4 ml-auto mr-4 font-bold text-center md:mr-auto lg:mr-auto sm:max-w-5xl md:w-2/3 lg:w-2/3 text-md`}
            >
              <button
                disabled={
                  Object.keys(itemQuantities).length !== 0 ? false : true
                }
                onClick={
                  activeList?.lock ? handleLockMessage : handleSaveChanges
                }
                className={`px-2 py-1 text-sm md:text-md lg:text-md border border-gray-200 rounded-md ${
                  Object.keys(itemQuantities).length !== 0
                    ? "bg-theme-color hover:bg-lighterPurple text-white"
                    : "bg-gray-400 text-gray-700"
                }`}
                style={{
                  display: activeList?.isOrderPlaced ? "none" : "block",
                  backgroundColor:
                    Object.keys(itemQuantities).length !== 0
                      ? selectedStore?.theme.backgroundColor
                      : "lightGray",
                }}
              >
                Save Changes
              </button>
            </div>
          )}
        </div>
      )}
      {isModalOpen && (
        <Modal
          modalData={modalContent}
          handleModalToggle={handleModalToggle}
          isOpen={isModalOpen}
          submitHandler={handlePlaceOrder}
        />
      )}
    </div>
  );
};

export default ReviewList;
